import {
  articleCategoryList,
  articleTypeList,
} from "@/api/ai-writer-service.js";

const state = {
  articleCategory: [],
  articleType: [],
  articleTypeObj: {},
};

const getters = {};

const mutations = {
  SET_ARTICLE(
    state,
    { articleCategory = [], articleType = [], articleTypeObj = {} } = {}
  ) {
    state.articleCategory = articleCategory;
    state.articleType = articleType;
    state.articleTypeObj = articleTypeObj;
  },
};

const actions = {
  // 获取稿件类别列表和获取稿件类型列表 (在App.vue初始化执行)
  async handleGetArticleCategoryAndType({ commit }) {
    const [articleCategory, articleType] = await Promise.all([
      articleCategoryList(),
      articleTypeList(),
    ]);
    const articleTypeObj = {};
    articleType.forEach((item) => {
      const articleCategoryName = item.articleCategoryName;
      if (!articleTypeObj[articleCategoryName]) {
        articleTypeObj[articleCategoryName] = [];
      }
      articleTypeObj[articleCategoryName].push(item);
    });
    articleCategory.forEach((item) => {
      const name = item.name;
      item.articleCategory = articleTypeObj?.[name] || [];
    });
    // 保存到仓库
    commit("SET_ARTICLE", {
      articleCategory,
      articleTypeObj,
      articleType,
    });
  },
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions,
};
